import Select, { components } from 'react-select'
import { ChevronDown } from '../icons'
import { placeholder } from 'polished'
import { P } from '@staccx/bento/lib/components/Text/Paragraph/Paragraph'
import SingleValue from 'react-select/dist/declarations/src/components/SingleValue'

const customStyles = {
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: 8,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#2969FF',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  control: (provided) => ({
    ...provided,
    border: '1px solid #D9D9D9',
    borderRadius: 8,
    padding: '0.25rem',
    boxShadow: 'none',
  }),
}

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="text-old-primary">
        <ChevronDown />
      </span>
    </components.DropdownIndicator>
  )
}

export function CustomSelect({
  label,
  options,
  value,
  onChange,
  id,
}: {
  label: string
  options: any[]
  value: string
  onChange: (value: string) => void
  id: string
}) {
  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="font-semibold" htmlFor={id}>
        {label}
      </label>
      <div className="relative overflow-visible">
        <Select
          components={{ DropdownIndicator }}
          styles={customStyles}
          options={options}
          value={options.find((option) => option.value === value)}
          onChange={(e) => onChange(e.value)}
        />
      </div>
    </div>
  )
}
